import React from 'react'

class ChangeStyleQR extends React.Component {

  state = {
    QRstyle: "QRNormal",    
  };

  
handleChange = (event) => {
	const {value} = event.target
    this.setState({ QRstyle: value })
	this.props.updateData(value);
  };


render() {
	    
       		
		return (
					<div className="buttonStyle">

					    <label>						
						  <p className="labelqr">v1 с логотипом в центре</p>
						  <input type="radio" name="QRstyle" value="QRNormal" className="radioqrstyle"  onChange={ this.handleChange.bind(this) } defaultChecked />						  
						  <img src="http://sbqr.ru/img/qrstyle/QRcode_A1.svg" alt="обычный QR с логотипом внутри" />
						</label>
						<label>						
						  <p className="labelqr">v2 с рисунком внутри</p>
						  <input type="radio" name="QRstyle" value="QRResImage" className="radioqrstyle" onChange={ this.handleChange.bind(this) } />						  
						  <img src="http://sbqr.ru/img/qrstyle/QRcode_C2.svg" alt="QR с рисунком внутри" />
						</label>
						<label>
						  <p className="labelqr">v3 с пузырями</p>
						  <input type="radio" name="QRstyle" value="QRBubble"  className="radioqrstyle" onChange={ this.handleChange.bind(this) } />						  
						  <img src="http://sbqr.ru/img/qrstyle/QRcode_SP_3.svg" alt="QR с подложкой" />
						</label>
						<label>
						  <p className="labelqr">v4 гравировка ручной работы</p>
						  <input type="radio" name="QRstyle" value="QRDsj" className="radioqrstyle" onChange={ this.handleChange.bind(this) } />						  
						  <img src="http://sbqr.ru/img/qrstyle/QRcode_SP-1.svg" alt="QR гравировка ручной работы" />
						</label>
						<label>
						  <p className="labelqr">v5 дополнительные направления</p>
						  <input type="radio" name="QRstyle" value="QRLine" className="radioqrstyle" onChange={ this.handleChange.bind(this) } />						  
						  <img src="http://sbqr.ru/img/qrstyle/QRcode_A-a1.svg"  alt="QR дополнительные направления" />
						</label>
						<label>
						  <p className="labelqr">v6 случайные кубики</p>
						  <input type="radio" name="QRstyle" value="QRRandRect" className="radioqrstyle" onChange={ this.handleChange.bind(this) } />						  
						  <img src="http://sbqr.ru/img/qrstyle/QRcode_SP_2.svg"  alt="QR случайные кубики" />
						</label>
					 <h4>Параметры дизайна. Выберите возможные стили QR кода ( доступно 6 разных дизайнов).</h4>						
					</div>

				
				)
}

}
export default ChangeStyleQR

